import React from "react";

import Map from "./Map";
import PhotoPin from "./maps/PhotoPin";
import RollLayer from "./maps/RollLayer";

const UserPhotoMap = ({
  imageId,
  imageLngLat,
  imageThumbnailUrl,
  imageUrl,
  zoom,
  imageVerified,
  rollGeoJsonUrl,
  coverages,
}) => {
  return (
    <Map center={imageLngLat} zoom={zoom} loader={false} allowExpand={true} coverages={coverages}>
      <RollLayer rollGeoJsonUrl={rollGeoJsonUrl} hideImageId={imageId} />
      <PhotoPin
        imageId={imageId}
        imageThumbnailUrl={imageThumbnailUrl}
        imageUrl={imageUrl}
        draggable={!imageVerified}
        location={imageLngLat}
      />
    </Map>
  );
};

import renderer from "../shared/renderer";
renderer(UserPhotoMap);
